let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5tsMc")).then(() => parcelRequire('3yZiu'));